import i18n from "src/i18n/config";
import { z } from "zod";

import { SimplePolicyRule } from "../types";

const rotationSetting = { command: "changeSetting", section: "System", type: "int", key: "user_rotation" };
const rotations = ["0", "1", "2", "3"] as const;
const screenRotationSchema = z.object({ rotation: z.enum(rotations) });

export const screenRotation: SimplePolicyRule<z.infer<typeof screenRotationSchema>> = {
    id: "screenRotation",
    title: () => i18n.t("modals:addRule.rules.screenRotation.title"),
    description: () => i18n.t("modals:addRule.rules.screenRotation.description"),
    details: () => i18n.t("modals:addRule.rules.screenRotation.details"),
    summary: (display) => i18n.t("modals:addRule.rules.screenRotation.summary", display),
    categories: ["display"],
    fields: [
        {
            type: "select",
            name: "rotation",
            label: () => i18n.t("modals:addRule.rules.screenRotation.rotation"),
            options: [
                { value: "0", label: () => "0°" },
                { value: "1", label: () => "90°" },
                { value: "2", label: () => "180°" },
                { value: "3", label: () => "270°" },
            ],
        },
    ],
    defaultValues: { rotation: "0" },
    schema: screenRotationSchema,
    command: rotationSetting,
    toValues: ({ rotation }) => rotation,
    fromValues: (rotation) => ({ rotation }),
    flags: [],
};
